export const sortPeriod = (periods = []) => {
  const currentYear = Number(localStorage.getItem('currentYear'))
  // const nextYear = currentYear + 1
  periods = periods
    .map(item => {
      let dateSlide
      if (item.period) {
        if (item.period.title) {
          dateSlide = item.period.title.slice(5).trim()
        }
      } else {
        dateSlide = item.title.slice(5).trim()
      }
      if (+dateSlide > 6 && +dateSlide <= 12) {
        item = {
          ...item,
          sort: `${dateSlide}${currentYear}`,
          displayTitle: `${item.title} / ${currentYear}`
        }
      } else {
        item = {
          ...item,
          sort: `${dateSlide}${currentYear}`,
          displayTitle: `${item.title} / ${currentYear}`
        }
      }
      return item
    })
    .sort((a, b) => +a.sort - +b.sort)
  return periods
}
